module.exports = __webpack_public_path__ + "static/media/workerimg.dc009f78.jpg";